import React, { useEffect, useState } from 'react'

import { Modal } from 'antd'
import { isFunction } from 'lodash'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import { getAllInstitutions } from '../../../utils/api/institution'
import { createLinkRequest, getAllLinkRequests } from '../../../utils/api/linkRequest'
import { onError, onSuccess, resolvePromises } from '../../../utils/apiHelper'
import Loading from '../../../Components/shared/Loading'
import SearchCheckboxList from '../../../Components/antd/Lists/SearchCheckboxList'

const LinkingInstitutionModal = ({ visible, onCancel, onOk }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [institutions, setInstitutions] = useState([])
  const [linkRequests, setLinkRequests] = useState([])
  const [selectedInstitutions, setSelectedInstitutions] = useState([])
  const [loading, setLoading] = useState(false)

  const availableInstitutions = institutions.filter(i => !linkRequests.find(lr => lr.target === i.id))

  useEffect(() => {
    let mounted = true

    getAllInstitutions(user, { filters: { premium: true, verified: true, managed: true, schools: { ne: { id: user.school?.id } } } }).then(({ data }) => {
      if (mounted) {
        setInstitutions(data)
      }
    }).catch(() => setInstitutions([]))
    getAllLinkRequests(user).then(({ data }) => {
      setLinkRequests(data)
    })

    return () => {
      mounted = false
    }
  }, [user])

  const handleOk = () => {
    const promises = []

    setLoading(true)

    selectedInstitutions.forEach(institution => {
      promises.push(createLinkRequest(user, { source: user.school.id, target: institution.id }))
    })

    resolvePromises(promises).then(responses => {
      const linkRequests = responses.map(r => r.data)

      setLinkRequests(prev => [...prev, ...linkRequests])

      if (isFunction(onOk)) {
        onOk(selectedInstitutions)
      }

      onSuccess(t('school_to_institution_link_request.success'))
    }).catch(() => {
      onError(t('school_to_institution_link_request.error'))
    }).finally(() => {
      setLoading(false)
      setSelectedInstitutions([])
    })
  }

  return (
    <Modal
      visible={!!visible}
      title={t('linking_institution_modal.title')}
      onOk={handleOk}
      onCancel={onCancel}
      okButtonProps={{ disabled: !selectedInstitutions.length || loading }}
      okText={t('linking_institution_modal.save')}
      cancelText={t('common.cancel')}
      centered
    >
      <div style={{ height: '400px' }}>
        {loading && (
          <Loading />
        )}
        {!loading && (
          <SearchCheckboxList
            data={availableInstitutions}
            label='name'
            onChange={setSelectedInstitutions}
          />
        )}
      </div>
    </Modal>
  )
}

export default LinkingInstitutionModal
